import axios from 'axios';
import config from 'api/urls-config.json';

export const getBlog = params => {
    return axios.get(`${config.API + config.pages.blog}`, { params });
};

// TODO use this for posts!
// TODO add Page number and limit
export const getPosts = params => {
    return axios.get(`${config.API + config.post_list}`, { params });
};

export const getPost = params => {
    const { slug, language, country } = params;

    return axios.get(`${config.API + config.pages.post_slug + slug}`, {
        params: {
            language,
            country,
        },
    });
};
